<template>
  <div class="buttons">

    <div :class="{'play-mode-box': true, 'active': this.$router.currentRoute.name == 'Play'}" v-if="activePlayModes.play">
      <router-link :to="{ name: 'Play', query: { exercise_id: exerciseId }}">
        <button @click="onModeClick('Play')">
          <font-awesome-icon icon="play" class="icon"/>
          <span>Play</span>
        </button>
      </router-link>
    </div>

    <div :class="{'learn-mode-box': true, 'active': this.$router.currentRoute.name == 'Learn'}" v-if="activePlayModes.learn">
      <router-link :to="{ name: 'Learn', query: { exercise_id: exerciseId }}">
        <button @click="onModeClick('Learn')">
          <font-awesome-icon icon="book-open" class="icon"/>
          <span>Learn</span>
        </button>
      </router-link>
    </div>

    <div :class="{'record-mode-box': true, 'active': this.$router.currentRoute.name == 'Record'}" v-if="activePlayModes.record">
      <router-link :to="{ name: 'Record', query: { exercise_id: exerciseId }}">
        <button @click="onModeClick('Record')">
          <font-awesome-icon icon="microphone-alt" class="icon"/>
          <span>Record</span>
        </button>
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PlayModesButtons',
  props: {
    exerciseId: String,
    activePlayModes: Object
  },
  methods: {
    onModeClick(mode) {
      if(mode == this.$route.name) {
        this.$emit('restart');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;

  .play-mode-box {
    width: 8rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.5rem;
    @media (max-width: 1200px) {
      width: 6rem;
      margin-right: 1rem;
    }
    @media (max-width: 900px) {
      width: 3rem;
    }
    @media (max-width: 450px) {
      width: 2.5rem;
    }

    a {
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    button {
      width: 100%;
      height: 2.5rem;
      font-size: 1.1rem;
      color: white;
      font-weight: bold;
      border: none;
      outline: none;
      background-color: #0f978a;
      border-radius: 0.3rem;
      transition: 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-left: 0.5rem;
        @media (max-width: 900px) {
          display: none;
        }
      }

      &:hover {
        cursor: pointer;
        background-color: #e6c17d;
      }
    }
  }

  .learn-mode-box {
    width: 8rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.5rem;
    @media (max-width: 1200px) {
      width: 6rem;
      margin-right: 1rem;
    }
    @media (max-width: 900px) {
      width: 3rem;
    }
    @media (max-width: 450px) {
      width: 2.5rem;
    }

    a {
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    button {
      width: 100%;
      height: 2.5rem;
      font-size: 1.1rem;
      color: white;
      font-weight: bold;
      border: none;
      outline: none;
      background-color: #0f978a;
      border-radius: 0.3rem;
      transition: 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-left: 0.5rem;
        @media (max-width: 900px) {
          display: none;
        }
      }

      &:hover {
        cursor: pointer;
        background-color: #e6c17d;
      }
    }
  }

  .record-mode-box {
    width: 8rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.5rem;
    @media (max-width: 1200px) {
      width: 6rem;
      margin-right: 1rem;
    }
    @media (max-width: 900px) {
      width: 3rem;
    }
    @media (max-width: 450px) {
      width: 2.5rem;
    }

    a {
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    button {
      width: 100%;
      height: 2.5rem;
      font-size: 1.1rem;
      color: white;
      font-weight: bold;
      border: none;
      outline: none;
      background-color: #0f978a;
      border-radius: 0.3rem;
      transition: 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-left: 0.5rem;
        @media (max-width: 900px) {
          display: none;
        }
      }

      &:hover {
        cursor: pointer;
        background-color: #e6c17d;
      }
    }
  }

  .active {
    button {
      background-color: #e6c17d;
      &:hover {
        cursor: pointer;
        background-color: #d1af70;
      }
    }
  }
}
</style>